
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import about1 from "../assets/WhyGrowCapital1.png";
import about2 from "../assets/WhyGrowCapital2.png";
import about3 from "../assets/WhyGrowCapital3.png";

const WhyGrowCapital = () => {
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);

  const cards = [
    {
      img: about1,
      title: "Market Research",
      text: "Don’t have time to trade daily? Forget frequent intraday moves and be part of our long-term investment plans. Build your portfolio with insights focused on strong and consistent returns.",
    },
    {
      img: about2,
      title: "Market Pro",
      text: "Choose from a diverse range of short-term investment options crafted for equity and commodity markets. Make smart trades guided by insights from our expert technical and fundamental analysts.",
    },
    {
      img: about3,
      title: "Support",
      text: "Support refers to the price range where a stock generally stops declining and finds buying interest. At this point, investors often step in to purchase, preventing the price from falling further.",
    },
  ];

  return (
    <section
      className="py-5"
      style={{
        backgroundColor: "transparent",
        textAlign: "center",
      }}
    >
      <div className="container">
        <h2
          className="fw-bold mb-5"
          style={{
            color: "#0d6efd",
            backgroundColor: "rgba(13,110,253,0.08)",
            display: "inline-block",
            padding: "10px 28px",
            borderRadius: "50px",
            fontSize: "1.9rem",
            letterSpacing: "0.5px",
          }}
        >
          WHY STOCK MARKET INVESTING BY GROW CAPITAL
        </h2>

        <div className="row justify-content-center g-4">
          {cards.map((card, index) => {
            const isHovered = hoveredCardIndex === index;

            const cardContainerStyle = {
              width: "95%",
              minHeight: "440px",
              backgroundColor: "#fff",
              border: "1px solid #f0f0f0",
              borderRadius: "1rem",
              overflow: "hidden",
              position: "relative",
              cursor: "pointer",
              transition:
                "transform 0.5s ease, box-shadow 0.5s ease, background-color 0.5s ease",
              boxShadow: isHovered
                ? "0 15px 35px rgba(13,110,253,0.4)"
                : "0 5px 15px rgba(0,0,0,0.05)",
              transform: isHovered ? "translateY(-15px)" : "translateY(0)",
            };

            const animatedBackgroundStyle = {
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: isHovered ? "100%" : "0%",
              backgroundColor: "#40a5e9ff",
              transition: "height 0.5s ease",
              zIndex: 0,
            };

            const contentWrapperStyle = {
              position: "relative",
              zIndex: 1,
              padding: "2.5rem 1.8rem",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center", // ✅ centers horizontally
              justifyContent: "flex-start", // ✅ keeps image at top
              textAlign: "center",
            };

            const imgContainerStyle = {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginBottom: "25px",
              marginTop: "10px",
            };

            const imgStyle = {
                width: "200px",   // 🔹 increased from 90px → 120px
               height: "200px",  
              width: "90px",
              height: "90px",
              borderRadius: "15px",
              objectFit: "contain",
              background: isHovered
                ? "rgba(255,255,255,1)"
                : "rgba(255,255,255,0.8)",
              padding: "6px",
              transition: "background 0.4s ease, transform 0.4s ease",
              transform: isHovered ? "scale(1.1)" : "scale(1)",
            };

            const titleStyle = {
              fontWeight: "bold",
              marginBottom: "1rem",
              fontSize: "1.3rem",
              color: isHovered ? "#fff" : "#0d6efd",
              transition: "color 0.3s ease",
            };

            const textStyle = {
              fontSize: "1rem",
              lineHeight: "1.7",
              color: isHovered ? "#fff" : "#555",
              transition: "color 0.3s ease",
            };

            return (
              <div
                key={index}
                className="col-md-4 col-sm-6 d-flex justify-content-center"
              >
                <div
                  style={cardContainerStyle}
                  onMouseEnter={() => setHoveredCardIndex(index)}
                  onMouseLeave={() => setHoveredCardIndex(null)}
                >
                  <div style={animatedBackgroundStyle}></div>
                  <div style={contentWrapperStyle}>
                    <div style={imgContainerStyle}>
                      <img src={card.img} alt={card.title} style={imgStyle} />
                    </div>
                    <h5 style={titleStyle}>{card.title}</h5>
                    <p style={textStyle}>{card.text}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyGrowCapital;
